import { map } from 'rxjs/operators'

import { ajax } from 'utils/rxfetch'

// All dashboard endpoints are proxied through the Django BE at
// /members-api/agents-dashboard/<name>[/<report_id>], which mints + caches
// the PSA KMS token server-side. The FE just rides session auth.
const PROXY_BASE = '/members-api/agents-dashboard'

const buildQuery = (params) => {
  if (!params) return ''
  const entries = Object.entries(params).filter(([, v]) => v != null && v !== '')
  if (entries.length === 0) return ''
  const qs = entries.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
  return `?${qs}`
}

const proxyGet = (name, params, extraPath = '') =>
  ajax({
    url: `${PROXY_BASE}/${name}${extraPath}${buildQuery(params)}`,
    method: 'GET',
    responseType: 'json',
  }).pipe(map((x) => x.response))

export default {
  getDashboard: (daysBack) => proxyGet('analytics-dashboard', { days_back: daysBack }),
  getPerformance: (daysBack) => proxyGet('analytics-performance', { days_back: daysBack }),
  getDmarc: (daysBack) => proxyGet('analytics-dmarc', { days_back: daysBack }),
  getRedirects: (daysBack) => proxyGet('analytics-redirects', { days_back: daysBack }),
  getAdoption: (daysBack) => proxyGet('analytics-adoption', { days_back: daysBack }),
  getTrendsOverview: (daysBack) => proxyGet('trends-overview', { days_back: daysBack }),
  getBriefing: (daysBack) => proxyGet('trends-briefing', { days_back: daysBack }),
  getInvestigationsFeed: (limit = 20, cursor = null, daysBack = null) =>
    proxyGet('feed-investigations', {
      limit,
      cursor,
      days_back: daysBack,
    }),
  getImpersonatedBrands: (daysBack, limit = 50, reportsPerBrand = 10) =>
    proxyGet('trends-impersonated-brands', {
      days_back: daysBack,
      limit,
      reports_per_brand: reportsPerBrand,
    }),
  getAgentInvestigationByReportId: (reportId) =>
    proxyGet('feed-investigations', null, `/${reportId}`),
  getIncidentPreviewByEid(eid, companyId) {
    const qs = companyId ? `?company_id=${companyId}` : ''
    return ajax({
      url: `/members-api/irontraps/incidents/preview/by-eid/${eid}${qs}`,
      method: 'GET',
      responseType: 'json',
    }).pipe(map((x) => x.response))
  },
}
